<div class="row" *ngIf="mergedOptions">
  <div class="col-sm-8">
    <mat-form-field class="full-width">
      <mat-label>{{ mergedOptions.dateLabel | translate }}</mat-label>
      <input id="{{idPrefix}}date"
             matInput [matDatepicker]="picker"
             [(ngModel)]="date"
             (dateChange)="sendUpdate()">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="col-sm-4">
    <mat-form-field class="full-width">
      <mat-label>{{ mergedOptions.timeLabel | translate }}</mat-label>
      <input id="{{idPrefix}}time"
             type="text" matInput
             [(ngModel)]="time"
             (blur)="onUpdateTime()"
             (focus)="onTimeFieldFocus();"
             [errorStateMatcher]="matcher"
             time-input>
      <mat-error>
        {{ 'error.invalid_time_format' | translate }}
      </mat-error>
    </mat-form-field>
  </div>
</div>
